import IndexPage from "./components/IndexPage.vue";
import StandardCalculator from "./components/calculators/StandardCalculator.vue";
import ReverseCalculator from "./components/calculators/ReverseCalculator.vue";
import EarlyRepayment from "./components/calculators/EarlyRepayment.vue";
import TvmAnnuity from "./components/calculators/TvmAnnuity.vue";
import LoanIrr from "./components/calculators/LoanIrr.vue";
import RetirementPlanner from "./components/calculators/RetirementPlanner.vue";
import LeasingCalculator from "./components/calculators/LeasingCalculator.vue";
import InvestmentAnalysis from "./components/calculators/InvestmentAnalysis.vue";
import BreakEvenAnalysis from "./components/calculators/BreakEvenAnalysis.vue";
import { createRouter,createWebHistory } from "vue-router";

const routes = [
    {
        path:"/index",
        redirect:'/'
    },
    {
        path: "/",
        name: "index",
        component: IndexPage,
        redirect: "/calc/standard",
        children: [
            { path: "calc/standard", name: "standard", component: StandardCalculator },
            { path: "calc/reverse", name: "reverse", component: ReverseCalculator },
            { path: "calc/prepay", name: "prepay", component: EarlyRepayment },
            { path: "calc/tvm", name: "tvm", component: TvmAnnuity },
            { path: "calc/irr", name: "irr", component: LoanIrr },
            { path: "calc/retirement", name: "retirement", component: RetirementPlanner },
            { path: "calc/leasing", name: "leasing", component: LeasingCalculator },
            {
                path: "invest",
                name: "invest",
                // child routes under /invest/
                children: [
                    { path: 'financing', name: 'invest-financing', component: InvestmentAnalysis }
                    ,{ path: 'bep', name: 'invest-bep', component: BreakEvenAnalysis }
                ]
            },
        ]
    }
];
const router = createRouter({
    history: createWebHistory(),
    routes: routes,
})

export default router;